import React, { useState, useCallback } from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  position: relative;
  cursor: none;
  display: block;
`;

const Img = styled.img`
  display: block;
  width: 100%;
  border-radius: ${({ $radius }) => $radius || '16px'};
`;

const Tooltip = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 9000;
  background: rgba(0, 0, 0, 0.78);
  color: #fff;
  padding: 7px 14px;
  border-radius: 100px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 7px;
  transform: translate(14px, 14px);
  transition: opacity 0.15s ease;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  left: ${({ $x }) => $x}px;
  top: ${({ $y }) => $y}px;
`;

const HandIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 11V6a2 2 0 0 0-4 0v5"/>
    <path d="M14 10V4a2 2 0 0 0-4 0v6"/>
    <path d="M10 10.5V6a2 2 0 0 0-4 0v8"/>
    <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/>
  </svg>
);

const ZoomImg = ({ src, alt, onClick, style, radius }) => {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [visible, setVisible] = useState(false);

  const handleMove = useCallback((e) => {
    setPos({ x: e.clientX, y: e.clientY });
  }, []);

  return (
    <>
      <Wrap
        onMouseMove={handleMove}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        onClick={onClick}
        style={style}
      >
        <Img src={src} alt={alt} $radius={radius} />
      </Wrap>
      <Tooltip $visible={visible} $x={pos.x} $y={pos.y}>
        <HandIcon />
        Tap to expand
      </Tooltip>
    </>
  );
};

export default ZoomImg;
